import { render, staticRenderFns } from "./SGPBoxPorcentagemComponent.vue?vue&type=template&id=7eb04a62"
import script from "./SGPBoxPorcentagemComponent.vue?vue&type=script&lang=js"
export * from "./SGPBoxPorcentagemComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPBoxPorcentagemComponent.vue?vue&type=style&index=0&id=7eb04a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports